import { Button, Flex, Tabs } from 'antd';
import { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Monitoring from '../../@shared/monitoring/Monitoring';
import OverviewPageStats from '../OverviewPageStats';
import { ClockCircleOutlined, FundProjectionScreenOutlined, LineChartOutlined, MessageOutlined, ReloadOutlined, StarOutlined } from '@ant-design/icons';
import FavoriteConversations from '../../@shared/FavoriteConversations';
import SMSList from '../../@shared/SMSList';
import JobsList from '../../@shared/JobsList';
import JobsContext from '../../../contexts/data/JobsContext';
import SMSContext from '../../../contexts/data/SMSContext';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import FavoriteConversationsContext from '../../../contexts/data/FavoriteConversationsContext';

enum TabKey {
  MONITORING = 'monitoring',
  OVERVIEW = 'overview',
  FAVORITE_CONVERSATIONS = 'favorite_conversations',
  SMS = 'sms',
  JOBS = 'jobs',
}

const LeedpulseOverview: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const jobsContext = useContext(JobsContext);
  const smsContext = useContext(SMSContext);
  const favoriteConversationsContext = useContext(FavoriteConversationsContext);

  const activeTab = searchParams.get('tab') || TabKey.MONITORING;

  const onTabChange = (key: string) => {
    setSearchParams(prev => {
      prev.set('tab', key);
      return prev;
    });
  };

  useEffect(() => {
    if (jobsContext.status !== ContextStatus.LOADING) {
      jobsContext.fetch(null, null);
    }
    return () => jobsContext.reset();
  }, []);

  useEffect(() => {
    if (smsContext.status !== ContextStatus.LOADING) {
      smsContext.fetch(null);
    }
    return () => smsContext.reset();
  }, []);

  useEffect(() => {
    if (favoriteConversationsContext.status === ContextStatus.IDLE) {
      favoriteConversationsContext.fetchFavorites();
    }
  }, [favoriteConversationsContext, favoriteConversationsContext.status]);


  return (
    <Tabs defaultActiveKey={activeTab} onChange={onTabChange}>
      <Tabs.TabPane tab={<Flex align="center"><FundProjectionScreenOutlined style={{ marginRight: 6 }} />Monitoring</Flex>} key={TabKey.MONITORING}>
        <Monitoring />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<Flex align="center"><LineChartOutlined style={{ marginRight: 6 }} />Vue d'ensemble</Flex>} key={TabKey.OVERVIEW}>
        <OverviewPageStats />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<Flex align="center"><StarOutlined style={{ marginRight: 6 }} />Conversations favorites</Flex>} key={TabKey.FAVORITE_CONVERSATIONS}>
        <FavoriteConversations />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<Flex align="center"><MessageOutlined style={{ marginRight: 6 }} />Reçus & envoyés</Flex>} key={TabKey.SMS}>
        <div style={{ marginBottom: "1rem", textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => smsContext.fetch(null)}
            icon={<ReloadOutlined />}
          >
            Rafraîchir
          </Button>
        </div>
        <SMSList scopedSubscriptionId={null} />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<Flex align="center"><ClockCircleOutlined style={{ marginRight: 6 }} />Messages planifiés</Flex>} key={TabKey.JOBS}>
        <div style={{ marginBottom: "1rem", textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => jobsContext.fetch(null, null)}
            icon={<ReloadOutlined />}
          >
            Rafraîchir
          </Button>
        </div>
        <JobsList scopedSubscriptionId={null} scopedContactId={null} />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default LeedpulseOverview;
